import React from 'react'
import styled from '@emotion/styled'
import { array, string } from 'prop-types'
import { makeImgResizerUrl } from '@jelly/utils'

// Styled Components via Emotion
const TestimonialsContainer = styled.div`
	height: auto;
	overflow: hidden;
	position: relative;
	width: 100%;
`
const Title = styled.h2`
	${({ theme }) => theme.maxWidth.L};
	color: ${({ theme }) => theme.colors.primary};
	font-size: 30px;
	font-weight: 300;
	line-height: 46px;
	margin: auto auto 3rem auto;
	padding-top: 30px;
	text-align: center;
	width: 90%;
`
const TestimonialWrapper = styled.div`
	display: flex;
	margin: 0 auto 50px;
	overflow: scroll;
	scroll-snap-type: x mandatory;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		position: relative;
		width: 100%;
	}
`
const ScrollingTestimonials = styled.div`
	display: flex;
	flex-direction: row;

	${({ theme }) => theme.MQ.XL} {
		margin: auto;
		scroll-snap-align: center;
	}
`
const TestimonialCard = styled.div`
	background: #f8fafb;
	font-size: 16px;
	line-height: 25px;
	margin: 0 1rem;
	padding: 2rem 2rem 3rem 2rem;
	scroll-snap-align: center;
	width: 292px;

	${({ theme }) => theme.MQ.M} {
		width: 567px;
	}
`
const ClientInfo = styled.div`
	align-items: center;
	display: flex;
	color: ${({ theme }) => theme.colors.primary};
	font-weight: 600;
	margin-top: 1rem;

	img {
		height: auto;
		width: 100px;
		margin-left: 0.5rem;
	}
`
Testimonials.propTypes = {
	imgUrl: string,
	listTestimonials: array,
	title: string,
}
function Testimonials({ listTestimonials, title }) {
	return (
		<TestimonialsContainer>
			<Title>{title}</Title>
			<TestimonialWrapper>
				<ScrollingTestimonials>
					{listTestimonials.map((testimonial, i) => {
						const { clientName, context, industry, logo } = testimonial
						return (
							<TestimonialCard key={i}>
								{context}
								<ClientInfo>
									{clientName}, {industry}
									{logo && (
										<img
											alt={`${clientName} logo`}
											className="lazyload"
											data-src={makeImgResizerUrl({ src: logo, method: 'w', w: '100' })}
										/>
									)}
								</ClientInfo>
							</TestimonialCard>
						)
					})}
				</ScrollingTestimonials>
			</TestimonialWrapper>
		</TestimonialsContainer>
	)
}

export default Testimonials
